import React from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  SimpleGrid,
  VStack,
  HStack,
  Icon,
  Image,
  useColorModeValue,
} from "@chakra-ui/react";
import { FaCheck } from "react-icons/fa";

const ProductFeatures = ({ product }) => {
  const textColor = useColorModeValue("gray.600", "gray.300");
  const headingColor = useColorModeValue("gray.800", "white");

  if (!product || !product.features || !Array.isArray(product.features) || product.features.length === 0) {
    return null;
  }

  return (
    <Box py={16} borderRadius="xl">
      <Container maxW="6xl">
        <VStack spacing={8} align="start">
          <VStack spacing={4} align="start" w="full">
            <Heading
              as="h2"
              size="xl"
              color={headingColor}
              textAlign="center"
              w="full"
            >
              Key Features of {product.title}
            </Heading>
            <Text
              fontSize="lg"
              color={textColor}
              textAlign="center"
              w="full"
              maxW="3xl"
              mx="auto"
            >
              Discover the powerful features that make {product.title} the perfect solution for your needs.
            </Text>
          </VStack>

          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6} w="full">
            {product.features.map((feature, index) => (
              <Box
                key={index}
                p={6}
                bg="gray.50"
                borderRadius="lg"
                border="1px"
                borderColor="gray.200"
                _hover={{
                  transform: "translateY(-2px)",
                  bg: "blue.50",
                  borderColor: "blue.200",
                }}
                transition="all 0.3s"
              >
                <HStack align="start" spacing={3}>
                  {/* Show icon if available, otherwise use FaCheck */}
                  {feature.icon ? (
                    <Image
                      src={feature.icon}
                      alt={feature.title}
                      boxSize={5}
                      objectFit="contain"
                    />
                  ) : (
                    <Icon as={FaCheck} color="green.500" boxSize={5} />
                  )}
                  <VStack align="start" spacing={1}>
                    <Text
                      fontSize="md"
                      fontWeight="semibold"
                      color={headingColor}
                      lineHeight="tall"
                    >
                      {typeof feature === 'string' ? feature : feature.title}
                    </Text>
                    {/* Show description if available */}
                    {feature.description && (
                      <Text
                        fontSize="sm"
                        color={textColor}
                        lineHeight="tall"
                      >
                        {feature.description}
                      </Text>
                    )}
                  </VStack>
                </HStack>
              </Box>
            ))}
          </SimpleGrid>
        </VStack>
      </Container>
    </Box>
  );
};

export default ProductFeatures;
